import { useEffect } from 'react';
import throttle from 'lodash.throttle';

export function useScrollListener(
  ref: React.RefObject<HTMLDivElement>,
  scrollHandler: (e: HTMLDivElement, evt?: Event) => void
) {
  const element = ref.current;
  useEffect(() => {
    if (element) {
      const throttledHandler = throttle(scrollHandler, 150);
      element.addEventListener('scroll', throttledHandler);

      return () => {
        element.removeEventListener('scroll', throttledHandler);
        throttledHandler.cancel();
      };
    }
  }, [element, scrollHandler]);
}
